import React from 'react';
import { useTheme } from '../ThemeContext';
import AccountSignIn from './AccountSignIn';
import HomeownerAccount from './HomeownerAccount';

/** Development-only look at the homeowner More account controls. */
export default function HomeownerAccountPreview() {
  const { colors } = useTheme();
  return (
    <main style={{ maxWidth: '40rem', margin: '0 auto', padding: '1.25rem', color: colors.text }}>
      <h2 style={{ marginTop: 0 }}>Account</h2>
      <div style={{ background: colors.surface, border: `1px solid ${colors.border}`, borderRadius: '1rem', padding: '1rem 1.25rem' }}>
        <AccountSignIn mode="homeowner" email="ada@example.com" colors={colors} />
      </div>
      <HomeownerAccount onDeleted={() => {}} onLoggedOut={() => {}} />
    </main>
  );
}
